export const FULL_PRICE = 14;
export const HALF_PRICE = 10; //FULL_PRICE / 2;
export const FULL_PRICE_PER_MINUTES = parseFloat(FULL_PRICE / 60);
export const HALF_PRICE_PER_MINUTES = parseFloat(HALF_PRICE / 60);

export const HourAndMinFormat = "HH:mm";

export const navBarItems = [
    { linkTo: "/", label: "Timer" },
    { linkTo: "/getranke", label: "Getränke" },
    { linkTo: "/reservierungen", label: "Reservierung" },
];
